import moment from 'moment'
import { defaultObj } from './state'
import isEmpty from '../../utility/isEmpty'

export default {
  setCustomerId (state, data) {
    state.customerId = data.customerId
  },

  setCustomerIds (state, data) {
    state.customerIds = data.customerIds
    state.customerAttributesCollected = true
  },

  setMdmId (state, value) {
    if (!isEmpty(value)) {
      state.mdmId = value
    }
  },

  setCustomerData (state, data) {
    if (this.cache.has('customer/getCustomerInfo') === true) {
      this.cache.delete('customer/getCustomerInfo')
    }

    if (data.customerIds) {
      state.customerIds = data.customerIds
    }
    if (data.customerId) {
      state.customerId = data.customerId
    }
    if (data.customerName) {
      state.customerName = data.customerName
    }
    if (data.fullCustomerName) {
      state.fullCustomerName = data.fullCustomerName
    }
    if (data.customerFirstName) {
      state.customerFirstName = data.customerFirstName
    }
    if (data.customerLastName) {
      state.customerLastName = data.customerLastName
    }
    if (data.dob) {
      state.dob = data.dob
    }

    if (data.customerStoreId) {
      state.customerStoreId = data.customerStoreId
    }
    if (data.addresses) {
      state.addresses = data.addresses
    }
    if (data.phoneNumber) {
      state.phoneNumber = data.phoneNumber
    }
    if (data.email) {
      state.email = data.email
    }
    if (data.incomeList) {
      state.incomeList = data.incomeList
    }
    if (data.lastPayDate) {
      state.lastPayDate = moment(data.lastPayDate)
    }
    if (data.payFrequency) {
      state.payFrequency = data.payFrequency
    }
    if (data.discretionaryIncome !== undefined) {
      state.discretionaryIncome = data.discretionaryIncome
    }

    if (data.canUpdateUserLogin) {
      state.canUpdateUserLogin = data.canUpdateUserLogin
    }

    if (!isEmpty(data.hasVerifiedProfileEmail)) {
      state.hasVerifiedProfileEmail = data.hasVerifiedProfileEmail
    }

    if (!isEmpty(data.hasVerifiedProfilePhone)) {
      state.hasVerifiedProfilePhone = data.hasVerifiedProfilePhone
    }

    if (data.banks !== undefined) {
      state.banks = data.banks
    }

    // Some people may not have these properties so we need to allow them to be set to undefined
    if (data.hasOwnProperty('displaySsn')) {
      state.displaySsn = data.displaySsn
    }

    if (data.hasOwnProperty('communicationSettings')) {
      state.communicationSettings = data.communicationSettings
    }
  },

  addBank (state, bankInfo) {
    if (this.cache.has('customer/getCustomerInfo') === true) {
      this.cache.delete('customer/getCustomerInfo')
    }

    state.banks = state.banks || []

    if (state.banks.some(bank => bank.id === bankInfo.id)) {
      return
    }

    state.banks.push(bankInfo)
  },

  setReferenceIds (state, referenceIds) {
    state.lmsReferenceIds = referenceIds
  },

  setReferralInfo (state, referralInfo) {
    state.referralInfo = referralInfo
  },

  setTempCommunicationSettings (state, data) {
    state.tempCommunicationSettings = data.tempCommunicationSettings
  },

  setGuestDocInfo (state, data) {
    state.dob = data.dob
    state.lastFourOfSSN = data.lastFourOfSSN
    state.customerReferralId = data.customerReferralId
  },

  clearCustomerData (state) {
    state.customerId = ''
    state.customerIds = {}
    state.mdmId = ''
    state.customerName = ''
    state.fullCustomerName = ''
    state.customerFirstName = ''
    state.customerLastName = ''
    state.dob = ''
    state.displaySsn = ''
    state.customerStoreId = ''
    state.addresses = []
    state.phoneNumber = ''
    state.email = ''
    state.status = 1
    state.lastPayDate = {}
    state.payFrequency = ''
    state.discretionaryIncome = 0
    state.banks = []
    state.brands = []
    state.referralInfo = {}
    state.communicationSettings = {}
    state.canUpdateUserLogin = false
    state.lastFourOfSSN = ''
    state.customerReferralId = ''

    if (this.cache.has('customer/getCustomerInfo') === true) {
      this.cache.delete('customer/getCustomerInfo')
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)

    if (this.cache.has('customer/getCustomerInfo') === true) {
      this.cache.delete('customer/getCustomerInfo')
    }
  }
}
